var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 90,
    viewBox: "0 0 88 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2429_2273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.6568 19.9877C65.7801 17.6627 60.5001 15.9752 55.0001 15.0002C54.9519 14.9986 54.9039 15.0079 54.8596 15.0273C54.8152 15.0467 54.7756 15.0759 54.7434 15.1127C54.0834 16.3502 53.3134 17.9627 52.8001 19.2002C46.9664 18.3002 41.0338 18.3002 35.2001 19.2002C34.6868 17.9252 33.9168 16.3502 33.2201 15.1127C33.1834 15.0377 33.0734 15.0002 32.9634 15.0002C27.4634 15.9752 22.2201 17.6627 17.3068 19.9877C17.2701 19.9877 17.2334 20.0252 17.1968 20.0627C7.22344 35.3252 4.47344 50.1752 5.8301 64.8752C5.8301 64.9502 5.86677 65.0252 5.9401 65.0627C12.5401 70.0127 18.8834 73.0127 25.1534 75.0002C25.2634 75.0377 25.3734 75.0002 25.4101 74.9252C26.8768 72.8627 28.1968 70.6877 29.3334 68.4002C29.4068 68.2502 29.3334 68.1002 29.1868 68.0627C27.0968 67.2377 25.1168 66.2627 23.1734 65.1377C23.0268 65.0627 23.0268 64.8377 23.1368 64.7252C23.5401 64.4252 23.9434 64.0877 24.3468 63.7877C24.4201 63.7127 24.5301 63.7127 24.6034 63.7502C37.2168 69.6377 50.8201 69.6377 63.2868 63.7502C63.3601 63.7127 63.4701 63.7127 63.5434 63.7877C63.9468 64.1252 64.3501 64.4252 64.7534 64.7627C64.9001 64.8752 64.9001 65.1002 64.7168 65.1752C62.8101 66.3377 60.7934 67.2752 58.7034 68.1002C58.5568 68.1377 58.5201 68.3252 58.5568 68.4377C59.7301 70.7252 61.0501 72.9002 62.4801 74.9627C62.5901 75.0002 62.7001 75.0377 62.8101 75.0002C69.1168 73.0127 75.4601 70.0127 82.0601 65.0627C82.1334 65.0252 82.1701 64.9502 82.1701 64.8752C83.7834 47.8877 79.4934 33.1502 70.8034 20.0627C70.7668 20.0252 70.7301 19.9877 70.6568 19.9877ZM31.2401 55.9127C27.4634 55.9127 24.3101 52.3502 24.3101 47.9627C24.3101 43.5752 27.3901 40.0127 31.2401 40.0127C35.1268 40.0127 38.2068 43.6127 38.1701 47.9627C38.1701 52.3502 35.0901 55.9127 31.2401 55.9127ZM56.7968 55.9127C53.0201 55.9127 49.8668 52.3502 49.8668 47.9627C49.8668 43.5752 52.9468 40.0127 56.7968 40.0127C60.6834 40.0127 63.7634 43.6127 63.7268 47.9627C63.7268 52.3502 60.6834 55.9127 56.7968 55.9127Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2429_2273",
    x: -4,
    y: 0,
    width: 96,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2429_2273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2429_2273",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.8cfc071b48e192e56272615536f49af4.svg";
export { ForwardRef as ReactComponent };